import React from 'react';
import { useAppLayoutStyles } from './AppLayout.styles';
import { Footer } from '../Footer';
import { ManagerDashboard } from '../ManagerDashboard';

export const AppLayout: React.FC = () => {
    const styles = useAppLayoutStyles();

    return (
        <div className={styles.container}>
            <div className={styles.mainContent}>
                <div className={styles.contentWrapper}>
                    <ManagerDashboard />
                </div>
                <Footer />
            </div>
        </div>
    );
};
